import React, {useState, useEffect, useRef } from 'react';
import Sidebar from './Sidebar'; 
import MainMenu from './MainMenu'; 
import AnalysisTabContent from './Analysis/AnalysisTabContent';
import AnalysisArea from './Analysis/AnalysisArea';
import AnalysisResizeHandle from './Analysis/AnalysisResizeHandle';
import { useDashboardContext } from '../context/DashboardContext';
import DashboardModal from './dashboard/DashboardModal';
import { useParams } from 'react-router-dom';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import SummaryArea from './Analysis/SummaryArea';
import { v4 as uuidv4 } from 'uuid';
import api from './api/api';

function AnalysisPage() {
    const ws = useRef(null);
    const { state, dispatch } = useDashboardContext(); // Contextから取得
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const [showDashboard, setShowDashboard] = useState(false);
    const [showAnalysisArea, setShowAnalysisArea] = useState(true);
    const [showAnalysisAreaSmall, setShowAnalysisAreaSmall] = useState(false);
    const [showSummaryAreaSmall, setShowSummaryAreaSmall] = useState(false);
    const [selectedCompanies, setSelectedCompanies] = useState([]);
    const [analysisAreaWidth, setAnalysisAreaWidth] = useState(); // デフォルトの幅を設定
    const [showStatus, setShowStatus] = useState('both'); // 表示されている方を表す
    const [searchAreaWidth, setSearchAreaWidth] = useState(null);
    const searchContainerRef = useRef(null);
    const [companyDescription, setCompanyDescription] = useState('');
    const [showMenu, setShowMenu] = useState(false);
    const mainContentsRef = useRef(null);
    const sidebarRef = useRef(null);
    const mainMenuRef = useRef(null); 
    const { secCode, page } = useParams(); // URLからuidとtokenを取得
    const [summaryData, setSummaryData] = useState({});
    const [summary, setSummary] = useState(null)
    const [showSummaryArea, setShowSummaryArea] = useState(false);
    const [summaryChatId, setSummaryChatId] = useState(null);
    const [recentEvent, setRecentEvent] = useState(null);
    const [resized, setResized] = useState(false);

    const handleOutsideClick = (event) => {
        if (
            (sidebarRef.current && sidebarRef.current.contains(event.target)) ||
            (mainMenuRef.current && mainMenuRef.current.contains(event.target)) 
        ) {
            return;
        }
        setShowMenu(false);
    };

    useEffect(() => {
        setSummaryChatId(uuidv4())
        document.addEventListener('click', handleOutsideClick);
        document.addEventListener('touchstart', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
            document.removeEventListener('touchstart', handleOutsideClick);
        };
        
    }, []);

    const onDashboardClick = (secCode) => {
        dispatch({ type: 'SET_SEC_CODE', payload: secCode})
        navigate(`/analysis/${secCode}/Summary`);
        setShowDashboard(true);
    }

    const onDashboardCloseClick = () => {
        setShowDashboard(false);
        navigate(`/analysis/`);
    }

    const onCompanyClick = (secCode, companyName) => {
        if (selectedCompanies.some((company) => company.secCode == secCode)) {
            setSelectedCompanies(selectedCompanies.filter(company => company.secCode !== secCode));

        } else {
            setSelectedCompanies([...selectedCompanies, {secCode: secCode, companyName: companyName}]);
        }
    }

    const onDeleteClick = (secCode) => {
        setSelectedCompanies(selectedCompanies.filter(company => company.secCode !== secCode));
    }

    const onDeleteAllClick = () => {
        setSelectedCompanies([]);
    }

    const handleResize = (newWidth) => {
        setSearchAreaWidth(newWidth); // 新しい幅をセットする
        setAnalysisAreaWidth(mainContentsRef.current.clientWidth - newWidth - 5); // 残りの幅を分析画面にセット
    };

    useEffect(() => {
        if (showStatus === 'right') {
            setAnalysisAreaWidth('100%');
        } else if (showStatus === 'left') {
            setSearchAreaWidth('100%');
        }

    }, [showStatus]) 

    useEffect(() => {
        console.log(searchAreaWidth)
    }, [searchAreaWidth])

    const addAllCompanies = (companies) => {
        setSelectedCompanies(companies);
    }

    const mainMenuClick = () => {
        setShowMenu(!showMenu)
    }

    const handleOpenAnalysis = () => {
        setShowAnalysisAreaSmall(true);     
    }

    const handleCloseAnalylsis = () => {
        setShowAnalysisAreaSmall(false);     
    }

    const summarize = async(chatId, doc_id, sec_code, category) => {
        setSummary(null)
        try {
            const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/${category}-summary/${sec_code}/${doc_id}/${chatId}/`, {
            }).then(res => { 
                setSummary(res.data);
            })
        } catch (error) {
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                setSummary({summary: "要約機能はログインが必要です。", key_point: []})
                // 未認証の場合、ログイン画面にリダイレクト
                // navigate('/login', { state: { from: location.pathname } });
            } else {
                console.error('Error ', error);
                setSummary({summary: "要約できませんでした。", key_point: []})
            }
        }
    }

    const getCompanyRecentEvent = async(company) => {
        try {
            setRecentEvent(null)
            const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/new-release-list-by-company/${company.sec_code}/`, {
            }).then(res => { 
                setRecentEvent(res.data.results);
            })
        } catch (error) {
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                // 未認証の場合、ログイン画面にリダイレクト
                // navigate('/login', { state: { from: location.pathname } });
            } else {
                console.error('Error ', error);
            }
            setRecentEvent([])
        }
    }

    const handleSummaryClick = (company, category) => {
        setSummary({
            summary: "",
            key_point: []
        })
        setShowSummaryArea(true);
        console.log(searchAreaWidth)
        if (searchAreaWidth <= 767) {
            setShowSummaryAreaSmall(true);
        } else {
            setShowSummaryAreaSmall(false);
        }
        setSummaryData(company);
        setShowAnalysisArea(false);    
        summarize(summaryChatId, company.doc_id, company.sec_code, category);
        getCompanyRecentEvent(company);
    }

    const handleCloseSummary = () => {
        setShowSummaryArea(false);
        setShowSummaryAreaSmall(false);
        setShowAnalysisArea(true);
      }

    useEffect(() => {
        if (secCode) {
            if (!state.secCode) {
                dispatch({ type: 'SET_SEC_CODE', payload: secCode });
            }
            const queryString = searchParams.toString();
            const expectedUrl = page
                ? `/analysis/${secCode}/${page}?${queryString}`
                : `/analysis/${secCode}/Summary?${queryString}`;
    
            // パラメータがすでに一致している場合は navigate しない
            if (window.location.pathname + window.location.search !== expectedUrl) {
                navigate(expectedUrl, { replace: true });  // replace で履歴に残さない
            }
    
            setShowDashboard(true);
        }
    }, [secCode, page, searchParams, navigate]);

    return (
        <>
            <MainMenu ref={mainMenuRef} handleClick={mainMenuClick} />
            <div className="main-container">
                <div ref={sidebarRef}>
                    <Sidebar selectedIcon="analysis" showMenu={showMenu} />
                </div>
                <div className="analysis-main-contents" ref={mainContentsRef}>
                    <div className="analysis-container-large">
                        {showStatus !== 'right' && (
                        <div
                            className={`tab-search-container ${showStatus === 'left' ? 'max-width' : ''}`}
                            style={{ width: searchAreaWidth }}
                            ref={searchContainerRef}
                        >
                            <AnalysisTabContent
                                selectedCompanies={selectedCompanies}
                                onCompanyClick={onCompanyClick}
                                onDashboardClick={onDashboardClick}
                                showStatus={showStatus}
                                addAllCompanies={addAllCompanies}
                                companyDescription={companyDescription}
                                setCompanyDescription={setCompanyDescription}
                                handleOpenAnalysis={handleOpenAnalysis}
                                analysisAreaOpend={showStatus !== 'left'}
                                handleSummaryClick={handleSummaryClick}
                                searchAreaWidth={searchAreaWidth}
                            />
                        </div>
                        )}

                        {(showAnalysisArea || showSummaryArea) && (
                        <>
                            {/* 常に表示するリサイズハンドル */}
                            <AnalysisResizeHandle
                            resizeHandle={handleResize}
                            setResized={setResized}
                            showStatus={showStatus}
                            setShowStatus={setShowStatus}
                            searchContainerRef={searchContainerRef}
                            />

                            {/* 左パネルが隠れていないときに、SummaryArea か AnalysisArea を切り替え */}
                            {showStatus !== 'left' && (
                            showSummaryArea ? (
                                <SummaryArea
                                selectedCompany={summaryData}
                                summary={summary}
                                resized={resized}
                                recentEvent={recentEvent}
                                width={analysisAreaWidth}
                                onClose={handleCloseSummary}
                                showSummaryAreaSmall={showSummaryAreaSmall}
                                />
                            ) : showAnalysisArea ? (
                                <AnalysisArea
                                    selectedCompanies={selectedCompanies}
                                    width={analysisAreaWidth}
                                    resized={resized}
                                    onDeleteClick={onDeleteClick}
                                    onDeleteAllClick={onDeleteAllClick}
                                    showAnalysisAreaSmall={showAnalysisAreaSmall}
                                    handleOpenAnalysis={handleOpenAnalysis}
                                    handleCloseAnalylsis={handleCloseAnalylsis}
                                />
                            ) : null
                            )}
                        </>
                        )}
                    </div>
                </div>
            </div>  
            {showDashboard && 
                <DashboardModal closeClickFunction={onDashboardCloseClick} />
            }    
        </>
    );
}

export default AnalysisPage;
